import PropTypes from 'prop-types';

import Component from './component';
import { container } from './container.module.scss';
import cx from 'classnames';

const Container = ({ className, children, ...props }) => {
  return (
    <Component className={cx(container, className)} {...props}>
      {children}
    </Component>
  );
};

Container.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default Container;
